export default function(){for(var n=[],t=arguments.length;t--;)n[t]=arguments[t];return function(t){n.forEach(function(n){"function"==typeof n?n(t):null!=n&&(n.current=t)})}}
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@quid/merge-refs/dist/index.es.js
// module id = 2678
// module chunks = 0